import { Injectable } from '@angular/core';
import { datadogLogs as datadog } from '@datadog/browser-logs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private initialized = false;
  constructor() {

    const isDataDogAllowed: boolean = Boolean(environment.production && environment.isDatadogAllowed);

    if (isDataDogAllowed) {
      datadog.init({
        clientToken: environment.dataDog.clientToken,
        site: environment.dataDog.site,
        service: environment.dataDog.service,
        env: environment.environmentIdentifier,
        version: environment.version,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
      });
      this.initialized = true;
    }
  }

  public debug(message: string, context?: { [x: string]: any }): void {
    if (this.initialized) {
      datadog.logger.debug(message, context);
    }
  }

  public info(message: string, context?: { [x: string]: any }): void {
    if (this.initialized) {
      datadog.logger.info(message, context);
    }
  }

  public warn(message: string, context?: { [x: string]: any }): void {
    if (this.initialized) {
      datadog.logger.warn(message, context);
    }
  }

  public error(message: string, context?: { [x: string]: any }): void {
    if (this.initialized) {
      datadog.logger.error(message, context);
    }
  }
}
